export {default} from './profile.vue'